<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Draggable 401k Video List</div>
                <button type="submit" v-on:click.prevent="add401kVideo" class="btn btn-primary waves-effect pull-right">Add</button>
                <div  class="col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right">
                    <v-select v-model="locationType"
                              name="locationType"
                              id="locationType"
                              label="text"
                              :clearable="false"
                              :searchable="false"
                              :filterable="false"
                              :options="locationTypeArr"
                              placeholder="Select Location Type">
                    </v-select>
                </div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="cards-container">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-4 mb-5">
                                <div class="cards-block">
                                    <div class="card">
                                        <img class="card-img-top" :src="text.image" :key="index">
                                        <div class="card-body">
                                            <button class="ml-2 mr-2 btn btn-danger pull-right"  v-on:click.prevent="delete401kVideo(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                            <router-link class=" btn btn-success pull-right" v-bind:to="{name: 'Update401kVideos',params:{id:text.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            'app-backend-footer': BackendFooter,
            draggable,
            'v-select': vSelect,
        },
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                imageList: [],
                imagePosition: [],
            }
        },
        watch: {
            locationType: function (locationType) {
                self.get401kVideos();
            },
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.get401kVideos();
        },

        methods: {
            add401kVideo() {
                self.$router.push('/backend/add401kvideos');
            },
            delete401kVideo: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("delete401kvideo", config)
                                .then(function (response) {
                                    self.get401kVideos();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            get401kVideos() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    'location_type': self.locationType.value,
                };
                self.showLoader();
                HTTP.post("get401kvideos", fields, config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                    'location_type': self.locationType.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepostion401kvideos", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/401kvideos/List401kVideos.vue